import { computed, type ComputedRef } from 'vue'
import { useSession } from '@/app/session'

/** The ledger's default payment account, the one account a user marks as preferred. */
export function useFavouriteAccountId(ledgerId: () => string | undefined): ComputedRef<string | undefined> {
  const session = useSession()
  return computed(
    () => session.ledgers.value.find((ledger) => ledger.id === ledgerId())?.defaultPaymentAccountId,
  )
}
